<div class="theme-interface">
  <div class="row px-2">
    <div
      class="tilesWrapper"
      [ngClass]="{ 'mb-6': gutterBottom, 'is-overflowing': isOverflowing }"
    >
      <!-- Scrollable category list -->
      <div
        #scrollContainer
        class="defaultCategoryContainer"
        [ngStyle]="currentStyles"
        (scroll)="onScroll()"
      >
        <div
          *ngFor="let catItem of topLevelCategories; trackBy: trackByCategoryId"
          role="presentation"
          class="text-unselectable defaultCategoryTab"
          [ngClass]="{ selected: selectedTopCat === catItem.categoryId }"
          id="defaultTab{{ catItem.categoryId }}"
          (click)="onSelectTopLevelCategory(catItem.categoryId)"
        >
          <div
            class="defaultCategoryImage"
            [style.background-image]="getBackgroundImage(catItem.standardImage)"
          ></div>
          <div
            class="defaultCategoryLabel font-size-primary text-center py-2"
            [ngClass]="{
              'font-weight-bold': selectedTopCat === catItem.categoryId,
              'theme-color-header': selectedTopCat === catItem.categoryId,
            }"
          >
            {{ catItem.name }}
          </div>
        </div>

        <div
          *ngIf="hasOtherTopLevelCategories"
          role="presentation"
          class="text-unselectable defaultCategoryTab"
          [ngClass]="{ selected: selectedTopCat === -1 }"
          (click)="onSelectTopLevelCategory(-1)"
        >
          <div class="defaultCategoryImage"></div>
          <div
            class="defaultCategoryLabel font-size-primary text-center py-2"
            [ngClass]="{
              'font-weight-bold': selectedTopCat === -1,
              'theme-color-header': selectedTopCat === -1,
            }"
          >
            {{ 'public.store.others' | translate }}
          </div>
        </div>
      </div>

      <!-- Sticky hamburger toggle -->
      <div
        role="presentation"
        class="text-unselectable view-toggle-tab"
        (click)="onViewToggle()"
      >
        <div
          class="view-toggle-icon d-flex align-items-center justify-content-center"
        >
          <i class="fas fa-bars" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>
